











































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { ErrorsMixin } from "@/employer/components/shared/ErrorsMixin";
import { mixins } from "vue-class-component";
import { formatCurrency } from "@/shared/currency.js";
import {
  DrivewealthAccountSummary,
} from "@/shared/types";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { roundToTwoDecimals } from "@/shared/mathHelper";
import _ from "lodash";
import moment from "moment/moment";

interface BalanceChange {
  percentage: number;
  dollar: number;
}

@Component
export default class CurrentHoldingsSummaryPanel extends mixins(ErrorsMixin) {
  formatCurrency = formatCurrency;
  roundToTwoDecimals = roundToTwoDecimals;

  drivewealthStore = useDrivewealthStore();

  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  @Prop({ required: false })
  accountId: number;

  loadData (): void {
    this.drivewealthStore.getAccountSummaryV2(
        { username: this.username, partnerId: this.partnerId, dwAccountId: this.accountId });
    this.drivewealthStore.loadAdvisoryFunds({ username: this.username, partnerId: this.partnerId });
  }

  @Watch("$props", { deep: true })
  reloadData (): void {
    this.loadData();
  }

  mounted (): void {
    this.loadData();
  }

  get accountSummary (): DrivewealthAccountSummary {
    return this.drivewealthStore.accountSummaryById(this.accountId);
  }

  get investmentBalance (): number {
    return this.accountSummary.displayBalance;
  }

  get lastUpdatedAccountPerformanceDate (): string {
    if (!this.accountSummary) {
      return "Not available.";
    }

    return moment().format("MM/DD/YYYY");
  }

  get previousDayChange (): BalanceChange {
    return this.calculateChange("unrealizedDayProfitLoss");
  }

  get totalChange (): BalanceChange {
    return this.calculateChange("unrealizedProfitLoss");
  }

  calculateChange (propertyName: string): BalanceChange {
    if (!this.accountSummary) {
      return {
        percentage: 0,
        dollar: 0
      };
    }

    const sumOfInvestmentChange = _.sumBy(this.accountSummary.holdings, x => {
      return x[propertyName];
    });

    const previousEquityValue = (sumOfInvestmentChange + this.accountSummary.equityValue);
    const currentEquityValue = this.accountSummary.equityValue;

    const percentageChange =  100 * (previousEquityValue - currentEquityValue) / ((previousEquityValue + currentEquityValue) / 2);
    const dollarChange = (previousEquityValue - currentEquityValue);

    return {
      percentage: _.isNaN(percentageChange) ? 0 : this.roundToTwoDecimals(percentageChange),
      dollar: dollarChange
    };
  }

  isPositiveNumber (value: number): boolean {
    return value > 0;
  }

  isNegativeNumber (value: number): boolean {
    return value < 0;
  }

  isZero (value: number): boolean {
    return value === 0;
  }

  get accountSummaryV2RequestLoaded (): boolean {
    return this.drivewealthStore.accountSummaryV2Loaded(this.accountId);
  }

  get isLoaded (): boolean {
    return this.accountSummaryV2RequestLoaded &&
        this.drivewealthStore.advisoryFundsLoaded;
  }
}
